"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var easy_peasy_1 = require("easy-peasy");
var ui_1 = __importDefault(require("./models/ui"));
var permission_1 = __importDefault(require("./models/permission"));
var models = {
    ui: ui_1.default,
    permission: permission_1.default,
};
var _a = easy_peasy_1.createTypedHooks(), useActions = _a.useActions, useStore = _a.useStore;
exports.useActions = useActions;
exports.useStore = useStore;
var store = function (appModels) { return easy_peasy_1.createStore(__assign({}, models, appModels)); };
exports.default = store;
